//* Vue
import type { SetupContext } from "vue";
//* 组件库
import type { UiForm, UiModal, UiTypes } from "various-ui";
import { $loading, $message } from "various-ui";
//* 公共函数
import { Rules } from "@/assets/js";
//* 组件属性
import type { Emits } from "../index";

export const useComposable = (emits: SetupContext<Emits>["emit"]) => {
    //* 插件
    const i18n = useI18n();
    //* 表单数据
    const data = reactive({ job: "", org: "", name: "", phone: "", email: "", exist: false });
    //* 表单校验规则
    const rules: Record<Exclude<keyof typeof data, "exist">, UiTypes.verifyRule[]> = {
        job: [{ trigger: "change", verify: () => ({ verify: !!data.job.trim(), message: "" }) }],
        org: [{ trigger: "change", verify: () => ({ verify: !!data.org.trim(), message: "" }) }],
        name: [{ trigger: "change", verify: () => ({ verify: !!data.name.trim(), message: "" }) }],
        email: [{ trigger: "change", verify: () => ({ verify: Rules.email(data.email), message: "" }) }],
        phone: [
            {
                trigger: "change",
                verify: () => {
                    // * 必填校验，仅中文表单触发
                    if (data.phone.trim()) return { verify: Rules.phone(data.phone), message: "" };
                    else {
                        if (i18n.locale.value == "zh") return { verify: false, message: "" };
                        else {
                            return { verify: true, message: "" };
                        }
                    }
                },
            },
        ],
    };

    //* 节点
    const nodes = {
        form: useTemplateRef<InstanceType<typeof UiForm>>("form"),
        modal: useTemplateRef<InstanceType<typeof UiModal>>("modal"),
    };

    //* 函数列表
    const methods = {
        close: () => nodes.modal.value?.closeModal(),
        open: () => {
            nodes.form.value?.reset();
            nextTick(() => {
                nodes.modal.value?.openModal();
            });
        },

        submit: () => {
            nodes.form.value?.validator((valid) => {
                if (!valid) $message.error(i18n.t("Placeholder.InputFormatError"));
                else {
                    $loading.open({ delay: 200 });
                    api.frontend("/api/bio/aav/consult", {
                        data: data,
                        method: "POST",
                        finally: () => $loading.close(),
                        success: () => {
                            localStorage.setItem("AAV_CAPSID_VIABILITY_PREDICTOR_FINGERPRINT", get_canvas_fingerprint());
                            methods.close();
                            emits("submit");
                        },
                    });
                }
            });
        },
    };

    return { data, rules, methods };
};
